import ImgSlot from '@/ui/ImgSlot';
import type { Drop } from '@/types';

import styles from './DropPanel.module.css';

interface DropPanelProps {
  drop: Drop;
}

export default function DropPanel({ drop }: DropPanelProps) {
  return (
    <div className={styles.root}>
      <div className={styles.img}>
        <ImgSlot label={`DROP COVER · ${drop.id}`} />
        <span className={`${styles.stamp} ${styles.stampTl}`}>DROP / {drop.id}</span>
        <span className={`${styles.stamp} ${styles.stampTr}`}>{drop.release}</span>
        <span className={`${styles.stamp} ${styles.stampBl}`}>IN FREQUENCY</span>
        <span className={`${styles.stamp} ${styles.stampBr}`}>◦ {drop.note}</span>
      </div>
      <div className={styles.meta}>
        <div className="line-row">
          <span>SYSTEM</span>
          <span className="line" />
          <span>{drop.code}</span>
        </div>
        <h2 className={styles.heading}>
          {drop.title}
          <br />
          <span className={styles.headingDim}>{drop.subtitle}</span>
        </h2>
        <div className={styles.rows}>
          <div>
            <label>STATE</label>
            <span>◦ AVAILABLE</span>
          </div>
          <div>
            <label>RELEASE</label>
            <span>{drop.release}</span>
          </div>
          <div>
            <label>ITEMS</label>
            <span>{drop.items} OBJECTS</span>
          </div>
          <div>
            <label>EDITION</label>
            <span>LIMITED RUN</span>
          </div>
          <div>
            <label>PICKUP</label>
            <span>HAYFILM CLUSTER · 04.2026</span>
          </div>
          <div>
            <label>SHIPPING</label>
            <span>FROM YEREVAN · 5–10D INTL</span>
          </div>
        </div>
      </div>
    </div>
  );
}
